import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { UserInfo } from 'src/app/Models/user-info';
import { UserProfile } from 'src/app/Models/user-profile';
//import { ApiService } from 'src/app/Services/api.service';
import { ProfileService } from 'src/app/Services/profile.service';
import { UserService } from 'src/app/Services/user.service';
import { GuiColumn } from '@generic-ui/ngx-grid';
import { name } from '@azure/msal-angular/packageMetadata';
import { Title } from '@angular/platform-browser';
import { UserAdd } from 'src/app/Models/user-add';
import { ListKeyManager } from '@angular/cdk/a11y';

// const GRAPH_ENDPOINT = 'https://graph.microsoft.com/v1.0/me';

// type ProfileType = {
//   givenName?: string,
//   surname?: string,
//   userPrincipalName?: string,
//   id?: string
// };

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.css']
})

export class UserComponent implements OnInit {
  profile : UserProfile;
  pnumber : string;
  //currentUserInfo$ : Observable<UserInfo>;
  currentUserInfo : any;
  //userProfile : UserProfile;
  userList : UserInfo[];
  userTypes : {};
  data: any[];
  selectedUserType : string;

  constructor(private userProfileService : ProfileService
              , private userService : UserService
              , private router: Router) { 
    //this.profile = this.router.getCurrentNavigation().extras.state;
  }

  ngOnInit(): void {
    this.currentUserInfo = this.userService.getCurrentUserInfo();
    console.log(this.currentUserInfo);
    if (this.currentUserInfo !== undefined && this.currentUserInfo !== null) {
      this.userService.getUserList_Adapter(this.currentUserInfo.userPNumber).subscribe(
        data => {
          this.userList = data;
          console.log(JSON.stringify(this.userList));
          this.userTypes = Array.from(new Set(this.userList.map((item: any) => item.userType)));
        }
      );
      // this.userTypes = this.userList.map(item => item.userType).filter((value, index, self) => self.indexOf(value) === index);
    }
    //this.currentUserInfo$ = this.userService.userInfo.subscribe();
    // this.currentUserInfo$ = this.userService.currentUserInfo$;
    else {
      this.currentUserInfo = this.userService.userInfo;
    }
    //.log("UserComponent init call, history state:");
    //console.log(JSON.stringify(history.state));
    //this.getProfile();
  }

  // getUserProfile_ApiService() {
  //   this.apiService.getJsonRestApi(GRAPH_ENDPOINT, 'Azure AD').subscribe(
  //     data => {
  //       this.profile = data;
  //     }
  //   );
  // }

  getProfile() {
    // this.userProfileService.getProfile().subscribe(
    //   data => {
    //     this.profile = data;
    //     this.pnumber = this.profile.userPrincipalName.substring(0, 9);
    //   }
    // );
    //this.profile = this.userProfile;
    this.profile = this.router.getCurrentNavigation().extras.state;
  }

  getProfile_ProServiceAdapter() {
    this.profile = this.userProfileService.getProfile();
    // this.userProfileService.getProfile_Adapter().subscribe(
    //   data => {
    //     this.profile = data
    //   }
    // );
  }

  getPolicyUserList() {
    if (this.pnumber !== "" && this.pnumber !== null && this.pnumber !== undefined) {

    }
  }
  
  addUser(event) {
    var content = new UserAdd;
    content.AdminUserPNumber = this.profile.userPrincipalName;
    content.UserPNumber = this.pnumber;
    content.UserType = this.selectedUserType;
  }

  onCreateConfirm(event: any): void {
    this.addUser(event);
  };

  onCustomEvent(event) {
    switch (event.action) {
      case 'Add':
        this.addUser(event);
        break;
    }
  }

  userListColumns: Array<GuiColumn> = [
    { header: 'Personnel Number',
      name: 'pNumber',
    },
    { header: 'Name',
      name: 'userName',
    },
    { header: 'User Type',
      name: 'userType',
    },
    { header: 'Active',
      name: 'active',
    },
    { header: 'Modified By User',
      name: 'modifiedByUser',
    },
    { header: 'Added By User',
      name: 'addedByUser',
    },
  ];

  settingsAdd = {
    //hideSubHeader: true,
    add: {
      addButtonContent: '+',
      // createButtonContent: 'OK',
      // cancelButtonContent: 'X',
      confirmCreate: true,
    },
    actions : {
      position : 'right',
      edit : false,
      delete : false,
      add : true
     },
    columns : {
        userPNumber : {
          title : 'Personnel Number',
        },
        userType : {
          title : 'User Type',
          editor : {
            type : 'list',
            config : {
              selectText: 'Select a User Type',
              list: [
                { value: '1', title: 'Admin'},
                { value: '2', title: 'User'}
              ]
            },
          },
          filter: {
            type: 'list',
            config: {
              selectText: 'Select a User Type',
              list: [
                { value: '1', title: 'Admin'},
                { value: '2', title: 'User'}
              ],
            },
          },
        },
    },
    noDataMessage: ''
  }

  
  settings = {
    hideSubHeader: true,
    actions : {
      position : 'right',
      add: false,
      new: false,
    },
    // actions : {
    //   custom : [ 
    //     {
    //       name : 'Button',
    //       title : 'Button',
    //     }
    //   ]
    // },
    columns: {
      // tableName : {
      //   title : 'Table Name',
      // },
      // userID : {
      //   title : 'User ID',
      // },
      index:{
        title: 'Seq.',
        type: 'text',
        valuePrepareFunction: (value,row,cell) => {
          return cell.row.index + 1;
         }
      },
      userName : {
        title : 'Name',
      },
      userPNumber : {
        title : 'Personnel Number',
      },
      userType : {
        title : 'User Type',
        filterFunction(cell?: any, search?: string): boolean {          
          return this.doFilter(cell, search);
        }
      },
      active : {
        title : 'Status',
      },
      // modifiedByUserID : {
      //   title : 'Modified By User ID',
      // },
      // modifiedByUser : {
      //   title : 'Modified By User',
      // },
      // addedByUserID : {
      //   title : 'Added By User ID',
      //   name : 'addedByUserID',
      // },
      // addedByUser : {
      //   title : 'Added By User',
      // },
    },
  }

  private anotherPromise(data: any[]) {
    this.data = data;
    //console.log(this.userListColumns);
    console.log(JSON.stringify(this.data));
  }

  doFilter(cell?: any, search?: string): boolean{
    return true;
  }

}
